import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

const LocationHeader = ({ links, title, action, authorized }) => {
  return (
    <>
      <div className="flex justify-between items-center py-3 px-1">
        <h2 className="font-bold text-xl sm:text-2xl text-text-1/85">
          {title}
        </h2>
        <div className="">
          {authorized && (
            <button onClick={() => action()} className="header-btn">
              <Plus size={20} />
            </button>
          )}
        </div>
      </div>
      {/* <div className="flex items-center justify-end px-1 py-3">
        <div className="rounded-md overflow-hidden flex gap-x-0.5 text-text-1/90 ">
          {links.map((link, index) => (
            <Link
              key={index}
              to={link.to}
              className="bg-bkg2 text-sm sm:text-base px-3 py-1 hover:bg-primary/80"
            >
              {link.name}
            </Link>
          ))}
        </div>
      </div> */}
    </>
  );
};

export default LocationHeader;
